import { render, staticRenderFns } from "./NewsDetailPageComponent.vue?vue&type=template&id=56745784&scoped=true&"
import script from "./NewsDetailPageComponent.vue?vue&type=script&lang=js&"
export * from "./NewsDetailPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56745784",
  null
  
)

export default component.exports